"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _emotion = require("emotion");

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _filter = _interopRequireDefault(require("lodash/filter"));

var _compact = _interopRequireDefault(require("lodash/compact"));

var _flatMap = _interopRequireDefault(require("lodash/flatMap"));

var _groupBy = _interopRequireDefault(require("lodash/groupBy"));

var _maxBy = _interopRequireDefault(require("lodash/maxBy"));

var _values = _interopRequireDefault(require("lodash/values"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _react = _interopRequireWildcard(require("react"));

var _logger = require("../../logger");

var statuses = _interopRequireWildcard(require("./entityStatus"));

var priceCompatibilityApi = _interopRequireWildcard(require("./priceCompatibilityApi"));

var _RevisionSelectorOptionList = _interopRequireDefault(require("./RevisionSelectorOptionList"));

var _SearchBar = _interopRequireDefault(require("./SearchBar"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  flex-shrink: 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var style = (0, _emotion.css)(_templateObject());
var searchStyle = (0, _emotion.css)(_templateObject2());

var isListPriceModel = function isListPriceModel(_ref) {
  var seller = _ref.seller,
      skus = _ref.skus,
      _ref$priceModel = _ref.priceModel,
      id = _ref$priceModel.id,
      revisionId = _ref$priceModel.revisionId,
      token = _ref.token,
      isProduction = _ref.isProduction;
  return priceCompatibilityApi.isListPriceModel({
    skus: skus,
    seller: seller,
    token: token,
    isProduction: isProduction,
    priceModel: {
      priceModelId: id,
      revisionId: revisionId
    }
  });
};

var filterListPriceModel =
/*#__PURE__*/
function () {
  var _ref3 = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee(_ref2) {
    var seller, skus, priceModel, token, isProduction;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            seller = _ref2.seller, skus = _ref2.skus, priceModel = _ref2.priceModel, token = _ref2.token, isProduction = _ref2.isProduction;
            _context.next = 3;
            return isListPriceModel({
              seller: seller,
              skus: skus,
              priceModel: priceModel,
              token: token,
              isProduction: isProduction
            });

          case 3:
            if (!_context.sent) {
              _context.next = 7;
              break;
            }

            _context.t0 = undefined;
            _context.next = 8;
            break;

          case 7:
            _context.t0 = priceModel;

          case 8:
            return _context.abrupt("return", _context.t0);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function filterListPriceModel(_x) {
    return _ref3.apply(this, arguments);
  };
}();

var removeListPriceModels =
/*#__PURE__*/
function () {
  var _ref5 = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee2(_ref4) {
    var seller, skus, priceModels, token, isProduction;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            seller = _ref4.seller, skus = _ref4.skus, priceModels = _ref4.priceModels, token = _ref4.token, isProduction = _ref4.isProduction;
            _context2.t0 = _compact.default;
            _context2.next = 4;
            return Promise.all(priceModels.map(function (priceModel) {
              return filterListPriceModel({
                seller: seller,
                skus: skus,
                priceModel: priceModel,
                token: token,
                isProduction: isProduction
              });
            }));

          case 4:
            _context2.t1 = _context2.sent;
            return _context2.abrupt("return", (0, _context2.t0)(_context2.t1));

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function removeListPriceModels(_x2) {
    return _ref5.apply(this, arguments);
  };
}();

var RevisionSelector =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(RevisionSelector, _PureComponent);

  function RevisionSelector(props) {
    var _this;

    (0, _classCallCheck2.default)(this, RevisionSelector);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RevisionSelector).call(this, props));
    _this.state = {
      revisions: {},
      revisionStatus: statuses.NOT_LOADED,
      search: '',
      searchDisplay: ''
    };

    _this.onChangeSearch = function (event) {
      var search = event.target.value;

      _this.setState({
        searchDisplay: search
      });

      _this.onSearch(search);
    };

    _this.onLoadRevisions =
    /*#__PURE__*/
    function () {
      var _ref6 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(sellerId, sellerType, skus) {
        var _this$props, isProduction, onGetAllRevisions, onGetAccessToken, onLoadingRevisions, onRevisionsLoaded, filterArchivedPriceModels, filterListPriceModels, token, revisions, filteredRevisions, revisionGroups, latestRevisions;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$props = _this.props, isProduction = _this$props.isProduction, onGetAllRevisions = _this$props.onGetAllRevisions, onGetAccessToken = _this$props.onGetAccessToken, onLoadingRevisions = _this$props.onLoadingRevisions, onRevisionsLoaded = _this$props.onRevisionsLoaded, filterArchivedPriceModels = _this$props.filterArchivedPriceModels, filterListPriceModels = _this$props.filterListPriceModels;
                onLoadingRevisions();

                _this.setState({
                  revisions: {},
                  revisionStatus: statuses.LOADING
                });

                token = onGetAccessToken();
                _context3.next = 6;
                return priceCompatibilityApi.fetchCompatiblePriceModels(skus, sellerId, sellerType, token, isProduction).catch(function () {
                  return null;
                });

              case 6:
                revisions = _context3.sent;

                if (revisions) {
                  _context3.next = 12;
                  break;
                }

                _this.setState({
                  revisions: {},
                  revisionStatus: statuses.UNAVAILABLE
                });

                _this.logger.error('Failed to load price model revisions', _this.componentName);

                _context3.next = 28;
                break;

              case 12:
                // remove the archived price models (where the archived field is set to true) if the flag is passed in as a prop
                filteredRevisions = filterArchivedPriceModels ? revisions.filter(function (rev) {
                  return !rev.archived;
                }) : revisions;
                revisionGroups = (0, _values.default)((0, _groupBy.default)(filteredRevisions, 'id'));
                latestRevisions = (0, _flatMap.default)(revisionGroups, function (group) {
                  return (0, _maxBy.default)(group, 'revisionId');
                }); // remove the price models that are list price models for any of the given SKUs if the flag filterListPriceModels is passed in as a prop

                if (!filterListPriceModels) {
                  _context3.next = 27;
                  break;
                }

                _context3.prev = 16;
                _context3.next = 19;
                return removeListPriceModels({
                  seller: {
                    sellerId: sellerId,
                    sellerType: sellerType
                  },
                  skus: skus,
                  priceModels: latestRevisions,
                  token: token,
                  isProduction: isProduction
                });

              case 19:
                latestRevisions = _context3.sent;
                _context3.next = 27;
                break;

              case 22:
                _context3.prev = 22;
                _context3.t0 = _context3["catch"](16);

                _this.setState({
                  revisions: {},
                  revisionStatus: statuses.UNAVAILABLE
                });

                _this.logger.error('Failed to load price model revisions', _this.componentName);

                return _context3.abrupt("return", onRevisionsLoaded());

              case 27:
                _this.setState({
                  revisions: latestRevisions,
                  revisionStatus: statuses.AVAILABLE
                }, function () {
                  return onGetAllRevisions && onGetAllRevisions(latestRevisions, filteredRevisions);
                });

              case 28:
                return _context3.abrupt("return", onRevisionsLoaded());

              case 29:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[16, 22]]);
      }));

      return function (_x3, _x4, _x5) {
        return _ref6.apply(this, arguments);
      };
    }();

    _this.onSearch = (0, _debounce.default)(function (search) {
      _this.setState({
        search: search
      });
    }, 200);

    _this.onSelect = function (priceModelId, revisionId, name) {
      var onChange = _this.props.onChange;
      onChange && onChange(priceModelId, revisionId, name);
    };

    _this.getSearchResults = (0, _memoizeOne.default)(function (latestRevisions, search) {
      var searchLower = search.toLowerCase();
      return (0, _filter.default)(latestRevisions, function (revision) {
        var idLower = revision.id.toLowerCase();
        var nameLower = revision.name.toLowerCase();
        return nameLower.includes(searchLower) || idLower === searchLower;
      });
    });
    _this.componentName = 'PriceModelRevisionSelector';
    _this.logger = (0, _logger.getLoggerForToken)(props.onGetAccessToken);

    _this.logger.info('PriceModelRevisionSelector in use', _this.componentName);

    return _this;
  }

  (0, _createClass2.default)(RevisionSelector, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          sellerId = _this$props2.sellerId,
          sellerType = _this$props2.sellerType,
          skus = _this$props2.skus;
      this.onLoadRevisions(sellerId, sellerType, skus);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props,
          sellerId = _this$props3.sellerId,
          sellerType = _this$props3.sellerType,
          skus = _this$props3.skus;
      var sellerChanged = sellerId !== prevProps.sellerId || sellerType !== prevProps.sellerType;
      var skusChanged = skus !== prevProps.skus;

      if (sellerChanged || skusChanged) {
        this.onLoadRevisions(sellerId, sellerType, skus);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          className = _this$props4.className,
          priceModelId = _this$props4.priceModelId,
          revisionId = _this$props4.revisionId,
          errorMessage = _this$props4.errorMessage;
      var _this$state = this.state,
          revisions = _this$state.revisions,
          revisionStatus = _this$state.revisionStatus,
          search = _this$state.search,
          searchDisplay = _this$state.searchDisplay;
      var latestRevisions = this.getSearchResults(revisions, search);
      return _react.default.createElement("div", {
        className: (0, _emotion.cx)(style, className)
      }, _react.default.createElement(_SearchBar.default, {
        className: searchStyle,
        value: searchDisplay,
        onChange: this.onChangeSearch
      }), _react.default.createElement(_RevisionSelectorOptionList.default, {
        priceModelId: priceModelId,
        revisionId: revisionId,
        revisions: latestRevisions,
        revisionStatus: revisionStatus,
        onSelect: this.onSelect,
        errorMessage: errorMessage
      }));
    }
  }]);
  return RevisionSelector;
}(_react.PureComponent);

RevisionSelector.defaultProps = {
  onLoadingRevisions: function onLoadingRevisions() {},
  onRevisionsLoaded: function onRevisionsLoaded() {},
  filterArchivedPriceModels: false,
  filterListPriceModels: false
};
var _default = RevisionSelector;
exports.default = _default;